import axios from "axios";

export default {
    Inventory: {
        async Table(data) {
            const response = await axios.post("/api/vehicleoperations/vehicleinventory/table", data);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/vehicleoperations/vehicleinventory/update" : "/api/vehicleoperations/vehicleinventory/create", data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/vehicleoperations/vehicleinventory/delete/${data}`);
            return response;
        },
        async GetById(id) {
            const response = await axios.get(`/api/vehicleoperations/vehicleinventory/get/${id}`);
            return response;
        },
        async ChangePlate(data) {
            const response = await axios.post("/api/vehicleoperations/vehicleinventory/changeplate", data);
            return response;
        },
        File: {
            async Table(data) {
                const response = await axios.post("/api/vehicleoperations/vehicleinventory/file/table", data);
                return response;
            },
            async Upload(data) {
                const response = await axios.post("/api/vehicleoperations/vehicleinventory/file/upload", data, { headers: { "Content-Type": "multipart/form-data" } });
                return response;
            },
            async Delete(data) {
                const response = await axios.post(`/api/vehicleoperations/vehicleinventory/file/delete/${data}`);
                return response;
            },
        },
    },
    Garage: {
        async Table(data) {
            const response = await axios.post("/api/vehicleoperations/vehicleinventorygarage/table", data);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/vehicleoperations/vehicleinventorygarage/update" : "/api/vehicleoperations/vehicleinventorygarage/create", data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/vehicleoperations/vehicleinventorygarage/delete/${data}`);
            return response;
        },
        async List() {
            const response = await axios.get("/api/vehicleoperations/vehicleinventorygarage/select/list");
            return response;
        },
        async ListByBranch(branchId) {
            const response = await axios.get("/api/vehicleoperations/vehicleinventorygarage/select/list/getbybranchid/" + branchId);
            return response;
        },
    },
    Duty: {
        async Table(data) {
            const response = await axios.post("/api/vehicleoperations/vehicleinventoryduty/table", data);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/vehicleoperations/vehicleinventoryduty/update" : "/api/vehicleoperations/vehicleinventoryduty/create", data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/vehicleoperations/vehicleinventoryduty/delete/${data}`);
            return response;
        },
    },
    Plate: {
        async Table(data) {
            const response = await axios.post("/api/vehicleoperations/vehicleplate/table", data);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/vehicleoperations/vehicleplate/update" : "/api/vehicleoperations/vehicleplate/create", data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/vehicleoperations/vehicleplate/delete/${data}`);
            return response;
        },
        async GetById(data) {
            const response = await axios.get(`/api/vehicleoperations/vehicleplate/get/${data}`);
            return response;
        },
        async ListAll(data) {
            const response = await axios.get(`/api/vehicleoperations/vehicleplate/select/listall`);
            return response;
        },
        async ListTruck() {
            return axios.get("/api/vehicleoperations/vehicleplate/truck/select/list");
        },
        async ListTrailer() {
            return axios.get("/api/vehicleoperations/vehicleplate/trailer/select/list");
        },
        async ListViaStatus(data) {
            const response = await axios.get(`/api/vehicleoperations/vehicleplate/select/list/${data}`);
            return response;
        },
        async ListViaNotUsingWithUsingPlate(data) {
            const response = await axios.get(!data ? "/api/vehicleoperations/vehicleplatenotusingwithusingplate/select/list" : `/api/vehicleoperations/vehicleplatenotusingwithusingplate/select/list/${data}`);
            return response;
        },
        async History(data) {
            const response = await axios.post("/api/vehicleoperations/vehicleplate/history", data);
            return response;
        },
    },
    HGSClassification: {
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/vehicleoperations/vehicleplate/hgsclassification/update" : "/api/vehicleoperations/vehicleplate/hgsclassification/create", data);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/vehicleoperations/vehicleplate/hgsclassification/delete/${id}`);
            return response;
        },
        async GetByPlateId(vehiclePlateId) {
            const response = await axios.get(`/api/vehicleoperations/vehicleplate/hgsclassification/getbyvehicleplate/${vehiclePlateId}`);
            return response;
        },
    },
    Operational: {
        async Table(data) {
            const response = await axios.post("/api/vehicleoperations/vehicleinventory/operational/table", data);
            return response;
        },
        async GetNotAssignedTrailer(isForTruck) {
            const response = await axios.get(`/api/vehicleoperations/vehicleinventory/notassignedtrailers/${isForTruck}`);
            return response;
        },
        async AssignTrailer(mainVehicleInventoryId, trailerVehicleInventoryId) {
            const response = await axios.post(`/api/vehicleoperations/vehicleinventory/assigntrailer/${mainVehicleInventoryId}/${trailerVehicleInventoryId}`);
            return response;
        },
        async UnassignTrailer(mainVehicleInventoryId) {
            const response = await axios.post(`/api/vehicleoperations/vehicleinventory/removetrailer/${mainVehicleInventoryId}`);
            return response;
        },
        async AssignGarageAndDuty(data) {
            const response = await axios.post("/api/vehicleoperations/vehicleinventory/assigntogarageandduty", data);
            return response;
        },
    },
};
